import { render, staticRenderFns } from "./MultipleDownloader.vue?vue&type=template&id=6df4056d"
import script from "./MultipleDownloader.vue?vue&type=script&lang=js"
export * from "./MultipleDownloader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports